import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Avenir-IT\\Documents\\Pizza App\\pizza-app-fe\\src\\components\\pages\\home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Avenir-IT\\Documents\\Pizza App\\pizza-app-fe\\src\\components\\preloader.tsx");
